import { useContext, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { generalGet } from '../../../API/api';
import TableSkeleton from '../../../components/loaders/TableSkeleton';
import { useTranslation } from 'react-i18next';
import { authContext } from '../../../store/context/authContext';
import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import VariantsEditLayout from '../../../modules/variants/components/VariantsEditLayout';
import { useParams } from 'react-router-dom';

const VariantEdit = () => {
  const { t, i18n } = useTranslation();
  const {variantId} = useParams()
  const { catchError } = useContext(authContext);

  const { data, isSuccess, isLoading, error } = useQuery({
    queryKey: ['varaints', variantId],
    queryFn: () => generalGet(`admin/variants/${variantId}`),
    refetchOnWindowFocus: false,
  });

  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      links: [{ label: t('links.vehicle_variants') }],
      page_title: data?.data?.data?.display_name?.[`${i18n.language as 'ar' | 'en'}`] || t("edit_variant"),
    })
  );

  useEffect(() => {
    // const reqData = data?.data.data;
    if (isSuccess) {
      // setVehicles(reqData);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    error && catchError(error);
  }, [catchError, error]);

  if (isLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="vehicles-page-container">
      <VariantsEditLayout />
    </div>
  );
};

export default VariantEdit;
